var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeverityIconsBlue24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Severity-sizes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6805 11.705L10.0989 1.88751C9.64021 1.1265 8.84737 0.666016 7.99577 0.666016C7.14416 0.666016 6.35132 1.1265 5.89265 1.88751L0.311032 11.705C-0.0902728 12.4145 -0.104144 13.2972 0.274646 14.0204C0.712715 14.8348 1.53013 15.3361 2.41415 15.3325H13.5774C14.4554 15.3425 15.2714 14.8538 15.7169 14.0513C16.107 13.3201 16.0931 12.4222 15.6805 11.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6805 11.705L10.0989 1.88751C9.64021 1.1265 8.84737 0.666016 7.99577 0.666016C7.14416 0.666016 6.35132 1.1265 5.89265 1.88751L0.311032 11.705C-0.0902728 12.4145 -0.104144 13.2972 0.274646 14.0204C0.712715 14.8348 1.53013 15.3361 2.41415 15.3325H13.5774C14.4554 15.3425 15.2714 14.8538 15.7169 14.0513C16.107 13.3201 16.0931 12.4222 15.6805 11.705ZM7.99577 12.2453C7.59386 12.2453 7.26804 11.8997 7.26804 11.4735C7.26804 11.0472 7.59386 10.7016 7.99577 10.7016C8.39767 10.7016 8.72349 11.0472 8.72349 11.4735C8.72349 11.8997 8.39767 12.2453 7.99577 12.2453ZM7.99577 9.92983C8.39767 9.92983 8.72349 9.58427 8.72349 9.15801V6.07075C8.72349 5.64449 8.39767 5.29893 7.99577 5.29893C7.59386 5.29893 7.26804 5.64449 7.26804 6.07075V9.15801C7.26804 9.58427 7.59386 9.92983 7.99577 9.92983Z",
    fill: "url(#paint0_linear_1507_77898)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1507_77898",
    x1: 0,
    y1: 0.666016,
    x2: 14.6113,
    y2: 16.6056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0132A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01277F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityIconsBlue24);
export default __webpack_public_path__ + "static/media/severity-icons-blue-24.fdf6de6b18f228e06f034e69c36f3b59.svg";
export { ForwardRef as ReactComponent };